import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';
import { ConfirmEmailSentComponent } from './forms/confirm-email-sent.component';
import { ConfirmPasswordResetComponent } from './forms/confirm-password-reset.component';
import { ResetPasswordFormComponent } from './forms/reset-password-form.component';
import { ForgotPasswordFormComponent } from './forms/forgot-password-form.component';
import { LoginFormComponent } from './forms/login-form.component';
import { LoginAuthGuard } from './login-auth-guard.service';
import { EstablishPasswordComponent } from './forms/establish-password.component';

const loginRoutes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [ LoginAuthGuard ],
    children: [
      { path: '', component: LoginFormComponent },
      { path: 'forgotPassword', component: ForgotPasswordFormComponent },
      { path: 'resetPassword', component: ResetPasswordFormComponent },
      { path: 'emailSent', component: ConfirmEmailSentComponent },
      { path: 'passwordReset', component: ConfirmPasswordResetComponent },
      { path: 'establishNewPassword', component: EstablishPasswordComponent}
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(loginRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class LoginRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/login/login-routing.module.ts